import React from "react";
import "../style/footer.css";
import { NavLink } from "react-router-dom";
import footerlogo from "../assets/footerlogo.png";
import arrowup from "../assets/arrowup.png";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="footer-container">
      <div className="footer-div1">
        <div className="footer-div1-items item-1">
          <img src={footerlogo} alt="footerlogo" loading="lazy" />
          <p>
            Providing compassionate residential care for individuals with
            learning disabilities, mental health challenges, and physical
            disabilities across the UK.
          </p>
        </div>

        <div className="footer-div1-items item-2 ">
          <h2>Quick Links</h2>

          <div className="footer-quick-links">
            <ul>
              <li>
                <NavLink to="/about-us">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/contact-us">Contact Us</NavLink>
              </li>
              <li>
                <NavLink to="/services"> Our Services</NavLink>
              </li>
              <li>
                <NavLink to="/meet-the-team">Meet the team</NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-div1-items item-3 ">
          <h2>Our Services</h2>
          <div className="footer-quick-links">
            <ul>
              <li>
                <NavLink to="/meet-the-team">Respite Care</NavLink>
              </li>
              <li>
                <NavLink to="/about-us">24/7 Residential Care</NavLink>
              </li>

              <li>
                <NavLink to="/services">Emergency Placement</NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-div1-items item-4 ">
          <h2>Contact Us</h2>
          <div className="footer-quick-links">
            <ul>
              <li>
                <NavLink to="/about-us">tel: 0121 769 3243</NavLink>
              </li>
              <li>
                <NavLink to="/meet-our-team">
                  info@serenityresidentialcare.co.uk
                </NavLink>
              </li>
              <li>
                <NavLink to="/services">
                  43 Vincent Street, Birmingham, UK, B12 9TP.
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-div2">
        <div onClick={scrollToTop} className="arrow-up">
          <img src={arrowup} alt="Scroll to top" />
        </div>
        <hr></hr>
        <div>
          © 2026 Serenity Residential Care. All rights reserved. |Privacy
          Policy |Terms of Service
        </div>
      </div>
    </div>
  );
};

export default Footer;
